import { TableCard } from 'app/components'
import { EsusEnvioListHeader } from './components/header/EsusEnvioListHeader'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { EsusEnvioListTable } from './table/EsusEnvioListTable'

/**
 * Listagem combinada dos envios ao PEC e-SUS APS.
 *
 * Não há bloqueio por vínculo aqui: quem determina as linhas visíveis é o backend, a partir do
 * usuário autenticado. Um super sem vínculo com empresa alguma continua vendo a lista combinada — era
 * justamente esse o caso que o bloqueio antigo impedia. Sem resultado, quem se manifesta é o vazio da
 * própria tabela.
 */
const EsusEnvioList = () => (
  <TableCard>
    <EsusEnvioListHeader />
    <EsusEnvioListTable />
  </TableCard>
)

export const EsusEnvioListPage = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <EsusEnvioList />
    </QueryResponseProvider>
  </QueryRequestProvider>
)
